import React from "react";
import Scanner from "../components/Scanner";
const ScanDevice = () => {
  return <Scanner />;
};

export default ScanDevice;
